import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import SelectorSpec from "./SelectorSpec";

var ModelBasedSelectorSpec = /*#__PURE__*/function (_SelectorSpec) {
  _inheritsLoose(ModelBasedSelectorSpec, _SelectorSpec);

  function ModelBasedSelectorSpec(_ref) {
    var _this;

    var model = _ref.model,
        other = _objectWithoutProperties(_ref, ["model"]);

    _this = _SelectorSpec.call(this, other) || this;
    _this._model = model;
    return _this;
  }

  _createClass(ModelBasedSelectorSpec, [{
    key: "resultFunc",
    get: function get() {
      var _this2 = this;

      return function (session, idArg) {
        for (var _len = arguments.length, other = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          other[_key - 2] = arguments[_key];
        }

        var ModelClass = session[_this2._model.modelName];

        if (typeof idArg === "undefined") {
          return ModelClass.all().toModelArray().map(function (instance) {
            return _this2.valueForInstance.apply(_this2, [instance, session].concat(other));
          });
        }

        if (Array.isArray(idArg)) {
          return idArg.map(function (id) {
            return _this2.valueForInstance.apply(_this2, [ModelClass.withId(id), session].concat(other));
          });
        }

        return _this2.valueForInstance.apply(_this2, [ModelClass.withId(idArg), session].concat(other));
      };
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    }
  }]);

  return ModelBasedSelectorSpec;
}(SelectorSpec);

export { ModelBasedSelectorSpec as default };